<template>
  <div class="BannerHome">
    <carousel
    v-if="banners.length"
    class="BannerHome__carousel"
    :perPage="1"
    :speed="1000"
    :paginationEnabled="true"
    :paginationActiveColor="'#009337'"
    :paginationColor="'#fff'"
    :autoplay="true"
    :autoplayTimeout="5000"
    :paginationPadding="5"
    :loop="true">
      <slide v-for="(item, indexBammer) in banners" :key="indexBammer">
        <div class="BannerHome__carousel__slide" :style="'background-image: url('+ item.background_image +')'">
          <div class="container h-100">
            <div class="row h-100  align-items-center"
            :class="{
              'justify-content-center': item.box_position == 'center',
              'justify-content-start': item.box_position == 'left',
              'justify-content-end': item.box_position == 'right'
            }"
            >
              <div class="col-md-12 col-lg-5 BannerHome__carousel__slide__imovel">
                <div class="row">
                  <div v-if="item.status" class="col-12 ui-description branco BannerHome__carousel__slide__imovel__status">
                    <p>{{item.status}}</p>
                  </div>
                  <div class="col-12 BannerHome__carousel__slide__imovel__titulo">
                    <h1 class="ui-home-title ui-home-title--white ui-title--left ui-home-title--uppercase">
                      <b>{{item.title}}</b>
                    </h1>
                  </div>
                  <div class="col-12 preview ui-description--white ui-description" v-if="item.preview">
                    <p>
                      {{item.preview}}
                    </p>
                  </div>
                  <div v-if="item.apartment_one" class="col-12 d-none d-md-block preview ui-description--white ui-description">
                    <p class="apartment_name">
                      {{item.apartment_one}}
                    </p>
                  </div>
                  <div v-if="item.characterist_one" class="col-6 d-none d-md-block ui-description--white ui-description">
                    <div class="box__titles__info">
                      <img v-if="item.characterist_image_one" :src="item.characterist_image_one" :alt="item.characterist_one">
                      <span>
                        {{item.characterist_one}}
                      </span>
                    </div>
                  </div>
                  <div v-if="item.characterist_two" class="col-6 d-none d-md-block ui-description--white ui-description">
                    <div class="box__titles__info">
                      <img v-if="item.characterist_image_two" :src="item.characterist_image_two" :alt="item.characterist_two">
                      <span>
                        {{item.characterist_two}}
                      </span>
                    </div>
                  </div>
                  <div v-if="item.apartment_two" class="col-12 d-none d-md-block preview ui-description--white ui-description">
                    <p class="apartment_name">
                      {{item.apartment_two}}
                    </p>
                  </div>
                  <div v-if="item.characterist_three" class="col-6 d-none d-md-block ui-description--white ui-description">
                    <div class="box__titles__info">
                      <img v-if="item.characterist_image_three" :src="item.characterist_image_three" :alt="item.characterist_three">
                      <span>
                        {{item.characterist_three}}
                      </span>
                    </div>
                  </div>
                  <div v-if="item.characterist_four" class="col-6 d-none d-md-block ui-description--white ui-description">
                    <div class="box__titles__info">
                      <img v-if="item.characterist_image_four" :src="item.characterist_image_four" :alt="item.characterist_four">
                      <span>
                        {{item.characterist_four}}
                      </span>
                    </div>
                  </div>
                  <div v-if="item.button_text" class="col-12 BannerHome__carousel__slide__imovel__cta">
                    <a :href="item.link">
                      <button class="ui-button ui-button--transparent">
                        {{item.button_text}}
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'BannerHome',
  props: ['images'],
  components: {
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters([
      'banners'
    ])
  },
  created () {
    this.$store.dispatch('loadBanners')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/_variables.scss';

.BannerHome{
  .preview {
    margin-top: 15px;
    .apartment_name{
      font-size: 20px;
      color: #fff;
      text-align: left;
      font-weight: 600;
      line-height: 36px;
      width: 100%;
      margin: 0px;
      margin-bottom: 15px;
    }
  }
  &__carousel{
    .VueCarousel-pagination{
      position: absolute;
      bottom: 1em;
      @media (max-width: 420px) {
        display: none;
      }
      .VueCarousel-dot-container{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .VueCarousel-dot{
          &-button{
            height: 18px!important;
            width: 18px!important;
            outline: none;
            box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.9);
          }
        }
        .VueCarousel-dot--active{
          .VueCarousel-dot-button{
            height: 23px!important;
            width: 23px!important;
          }
        }
      }
    }
    &__slide{
      height: 92vh;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      @media (max-width: 1400px) and (max-height: 1100px){
        height: 88vh;
      }
      @media (max-width: 1024px) {
        height: 94vh;
      }
      @media (max-width: 992px) {
        height: 100vh;
      }
      &__imovel{
        background-color: rgba($primary, 0.8);
        border-bottom: 10px solid $green;
        padding: 30px;
        margin-top: 6.5em;
        @media (max-width: 500px) {
          margin-top: 3em;
          padding: 15px;
        }
        @media (max-width: 340px) {
          margin-top: 7em;
        }
        &__status{
          p{
            line-height: 18px;
            margin-bottom: 18px;
          }
          .business_status{
            float: left;
            padding-right: 15px;
          }
        }
        &__titulo{
          h1{
            margin: 0px;
            b{
              line-height: 50px;
              margin: 0px;
            }
            @media (max-width: 1400px) and (max-height: 1100px){
              font-size: 40px;
            }
            @media (max-width: 500px) {
              font-size: 45px;
            }
            @media (max-width: 400px) {
              font-size: 26px;
            }
          }
        }
        &__dados{
          img {
            max-width: 48px;
            max-height: 48px;
          }
          span {
            color: white;
            line-height: 20px;
            font-weight: 300;
            font-size: 15px;
          }
          p{
            color: #fff;
            font-family: $font-family;
            font-size: 22px;
            font-weight: 600;
            line-height: 26px;
            margin-top: 2.3em;
            @media (max-width: 420px) {
              margin-top: 1em;
            }
            @media (max-width: 320px) {
              margin-top: 0.5em;
            }
            @media (max-width: 1400px) and (max-height: 1100px){
              margin-top: 0.7em;
            }
          }
          ul{
            display: flex;
            justify-content: space-between;
            margin: 0px;
            li{
              padding-right: 15px;
              color: #fff;
              display: flex;
              align-items: center;
              font-style: italic;
              font-size: 16px;
              img{
                padding-right: 10px;
                filter: grayscale(100%) brightness(300%);
                @media (max-width: 400px) {
                  max-width: 40px;
                }
              }
              @media (max-width: 400px) {
                font-size: 13px;
              }
            }
          }
        }
        &__cta{
          text-align: center;
          margin-top: 50px;
          @media (max-width: 320px) {
            margin-top: 15px;
          }
          @media (max-width: 1400px) and (max-height: 1100px){
            margin-top: 15px;
          }
          button{
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BannerHome.vue